import { Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { warningAlert } from "../../../common/components/Toasts/CustomToasts";
import CustomInput from "../../../common/components/CustomInput";
import { getComplaints } from "../services/EMRServices/emrServices";
import React from "react";
import {
  DeleteIcon
} from "./EmrCommonAsset/Asset";
import PastComplaint from "./PastComplaint";
const durationData = [
  {
    value: "Days",
    label: "D",
  },
  {
    value: "Months",
    label: "M",
  },
  {
    value: "Years",
    label: "Y",
  },
];
export default function AncComplaints(props) {
  const [save, setSave] = useState(false);
  const {
    complaintsData,
    setComplaintsData,
    dataComplaints,
    setDataComplains,
    markFavoriteData,
    patientHistoryData,
    setPatientHistoryData,
  } = props;
  const [openAddComplaints, setOpenAddComplaints] = useState(false);
  const [complaintsChipsList, setComplaintsChipsList] = useState([]);
  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [allComplaintsChipsList, setAllComplaintsChipsList] = useState([]);
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [selectedChips, setSelectedChips] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [openPastComplaint, setOpenPastComplaint] = useState(false);
  const [complaintsList, setComplaintsList] = useState([]);

  const defaultValues = {
    complaint: null,
  };
  const {
    control,
    watch,
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useFormContext({
    mode: "onChange",
    defaultValues,
    // resolver: yupResolver(validationSchema),
  });
  function deleteRow(index) {
    if (complaintsData) {
      const newComplaintsData = [...complaintsData];
      newComplaintsData.splice(index, 1);
      setComplaintsData(newComplaintsData);
      setDataComplains(newComplaintsData);
    } else {
      // Handle the case when complaintsData is undefined
      console.error("complaintsData is undefined");
    }
  }
  const handleChange = (e) => {
    if (e.length > 0) {
      if (UseCheckConsecutiveCharacters(e)) {
        getComplaints(e)
          .then((response) => {
            setComplaintsList(response.data.result);
          })
          .catch((response) => {
            console.log(response);
          });
      }
    } else if (e === "" || e === undefined || e === null) {
      setComplaintsList([]);
    }
  };
  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              setEditOpen(true);
              setEdit(true);
              setRow(row);
              setIndex(index);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip> */}

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  //function to Get Allergies Chips
  // const handleComplaintsChips = () => {
  //   getComplaints(null)
  //     .then((response) => {
  //       setAllComplaintsChipsList(response.data.result);
  //       let chipsAllergies = [];
  //       response.data.result.map((item) => {
  //         // if (item.isCommon) {
  //         chipsAllergies.push(item);
  //         // }
  //       });
  //       setComplaintsChipsList(chipsAllergies);
  //     })
  //     .catch((err) => {
  //       console.log("Error");
  //     });
  // };

  // useEffect(() => {
  //   handleComplaintsChips();
  // }, []);

  useEffect(() => {
    if (save === true) {
      setComplaintsData([...dataComplaints]);
      setSave(false);
    }
  }, [save]);
  let complaint = watch("complaint");
  let duration = watch("duration");
  let since = watch("since");

  useEffect(() => {
    if (complaint !== null && complaint !== undefined && complaint !== "") {
      let obj = {
        complaint:
          complaint?.label !== undefined ? complaint?.label : complaint?.label,
        duration:
          duration?.label !== undefined ? duration?.label : duration?.label,
        since: since !== undefined ? since : since,
        isNew:
          complaint?.__isNew__ !== undefined && complaint?.__isNew__ === true
            ? true
            : false,
      };
      let temp = complaintsData.some(
        (item) => item.complaint === complaint?.label,
      );

      if (temp === true) {
        warningAlert("Already Present Record..!");
        setValue("complaint", null);
        // setOpenPost(false);
      } else {
        if (
          complaint?.label !== null &&
          complaint?.label !== undefined &&
          complaint?.label !== ""
        ) {
          setComplaintsData((prevState) => [...prevState, obj]);
          setValue("complaint", null);
          setValue("duration", null);
          setValue("since", "");
          setSelectedComplaint(null);
        }
      }
    }
  }, [complaint]);
  const renderInput = (row, index, header) => {
    setValue(`duration${index}`, {
      value: row.Duration,
      label: row.Duration,
    });
    setValue(`since${index}`, row.Since);
    return (
      <>
        {header === "Duration" && (
          <div className="w-full flex gap-2">
            {/* <TableDropDownField
              control={control}
              name={`duration${index}`}
              placeholder="Duration"
              dataArray={durationData}
              inputRef={{
                ...register(`duration${index}`, {
                  onChange: (e) => {
                    console.log(" e.target.value", e.target.value);

                    let tempData = [...complaintsData];
                    tempData[index].duration = e.target.value?.label;
                    setComplaintsData(tempData);
                  },
                }),
              }}
              menuPlacement="bottom"
            /> */}
            {durationData.map((item, durationIndex) => {
              return (
                <div className="flex gap-2 ">
                  <button
                    // disabled={pastData !== null}
                    type="button"
                    disabled={row.Since === "" || row.Since === undefined}
                    onClick={(e) => {
                      let tempData = [...complaintsData];

                      if (tempData[index].duration === item.value) {
                        tempData[index].duration = null;
                      } else {
                        tempData[index].duration = item.value;
                      }

                      setComplaintsData(tempData);
                    }}
                    className={`${
                      row.Duration === item?.value
                        ? "bg-[#29adda] text-white rounded-full border"
                        : "text-black rounded-full border"
                    } w-5 h-5 pt-[2px] border border-gray-400 pl-[1px] rounded-full text-[12px] font-semibold`}
                  >
                    {item?.label}
                  </button>
                </div>
              );
            })}
          </div>
        )}
        {header === "Since" && (
          <div className="w-20">
            <CustomInput
              control={control}
              name={`since${index}`}
              // label="Since"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              inputRef={{
                ...register(`since${index}`, {
                  onChange: (e) => {
                    let tempData = [...complaintsData];
                    tempData[index].since = e.target.value;
                    if (
                      tempData[index].duration === undefined ||
                      tempData[index].duration === ""
                    ) {
                      tempData[index].duration = "Days";
                    } else if (
                      tempData[index].duration !== undefined ||
                      tempData[index].duration !== ""
                    ) {
                      tempData[index].duration = " ";
                    }

                    setComplaintsData(tempData);
                  },
                }),
              }}
            />
          </div>
        )}
      </>
    );
  };
  // const handleClickComplaints = () => {
  //   getComplaintsChips(null)
  //     .then((response) => {
  //       setComplaintsList(response.data.result);
  //     })
  //     .catch((response) => {

  //     });
  // };
  return (
    <div className="">
      <div className="flex justify-between bg-[#DCFCE7] rounded-t-md w-full">
        <div className="">
          {" "}
          <p
            className={`${
              props.from === "Wellness" ? "pt-2" : "pt-1"
            } text-sm font-semibold pl-2 `}
          >
            Complaints
          </p>{" "}
        </div>
        <div
          className={`${
            props.from === "Wellness" ? "w-[200px]" : "w-[300px]"
          } flex gap-2`}
        >
          {/* <button
            type="button"
            onClick={() => {
              setOpenAddComplaints(true);
              setSave(false);
            }}
          >
            <div className="flex justify-between border w-36 mx-2 bg-white">
              <p className="text-xs my-auto px-2">Complaints</p>
              <SearchIcon />
            </div>
          </button> */}
          <fieldset
            className="w-full"
            onClick={() => {
              // handleClickComplaints();
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <SearchDropdown
              focused={true}
              control={control}
              error={errors.complaint}
              name="complaint"
              placeholder="Complaints"
              dataArray={complaintsList}
              isSearchable={false}
              onInputChange={handleChange}
              menuPlacement="bottom"
            />
          </fieldset>
          {/* {
            props.from === "Wellness" ?(""):(  <button
              type="button"
              onClick={() => {
                setOpenPastComplaint(true);
                // setSave(false)
              }}
            >
            <HistoryIcon />
          </button>)
          } */}
        </div>
      </div>
      <div
        className={`${
          props.from === "Wellness" ? "h-[9.30rem]" : "h-[9.30rem]"
        } border  border-b-[#D9D9D9]  overflow-y-auto border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md`}
      >
        <div className="flex justify-between  ">
          <div className="flex space-x-2 pl-2">
            {markFavoriteData?.complaint &&
              markFavoriteData?.complaint
                .slice(0, chipsCount)
                .map((item, index) => {
                  const isCheck = complaintsData?.some(
                    (val) => val?.complaint === item.label,
                  );
                  return (
                    <>
                      {/* {item.isCommon && ( */}
                      <button
                        type="button"
                        // className="border border-black center relative inline-block select-none whitespace-nowrap rounded-full bg-white py-2 px-3.5 align-baseline text-xs  leading-none text-black"
                        key={index}
                        className={`mr-[5px] mb-1 capitalize h-[27px] px-3 w-max rounded text-sm border border-gray-300 whitespace-nowrap ${
                          complaintsData?.some(
                            (val) => val?.complaint === item.label,
                          )
                            ? "bg-[#32819b] text-white rounded-full border"
                            : "text-black rounded-full border"
                        }`}
                        // disabled={complaintsData?.some(
                        //   (val) => val?.complaint === item.label
                        // )}
                        onClick={() => {
                          // if (selectedChips.includes(item)) {
                          // } else {
                          // setSelectedChips([...selectedChips, item]);
                          // }
                          // setSelectedComplaint(item);
                          // setOpenAddComplaints(true);
                          setValue("complaint", item);
                        }}
                      >
                        {item.label}
                      </button>
                      {/* )} */}
                    </>
                  );
                })}
          </div>
        </div>
        {/* max-h-[12rem] overflow-scroll scrollbar-thin  scrollbar-thumb-blue-200 scrollbar-track-blue-50 */}
        <>
          {complaintsData?.length > 0 ? (
            <div className=" ">
              <CommonTransactionTable
                dataResult={complaintsData.map((row) => ({
                  Complaints: row.complaint,
                  Since: row.since,
                  Duration: row.duration,
                  isNew: row?.isNew,
                }))}
                renderActions={renderAction}
                highlightRow={false}
                removeHeaders={["isNew"]}
                editableColumns={["Duration", "Since"]}
                renderInput={renderInput}
              />
            </div>
          ) : null}{" "}
        </>

        <div className="">
          {/* <ComplaintsModal
            complaintsData={complaintsData}
            setComplaintsData={setComplaintsData}
            dataComplaints={dataComplaints}
            setDataComplains={setDataComplains}
            allComplaintsChipsList={allComplaintsChipsList}
            selectedChips={selectedChips}
            setSelectedChips={setSelectedChips}
            // complaints={props.complaints}
            setOpenAddComplaints={setOpenAddComplaints}
            selectedComplaint={selectedComplaint}
            setSelectedComplaint={setSelectedComplaint}
            selectedDuration={selectedDuration}
            setSelectedDuration={setSelectedDuration}
            // finalEditInfo={finalEditInfo}
            // finalEditId={finalEditId}
            // setFinalEditId={setFinalEditId}
            // handleSelectedChip={handleSelectedChip}
            openAddComplaints={
              openAddComplaints === true ? openAddComplaints : editOpen
            }
            setEditOpen={setEditOpen}
            data={data}
            setData={setData}
            edit={edit}
            setEdit={setEdit}
            row={row}
            index={index}
            setSave={setSave}
            save={save}
          /> */}
        </div>
        <div>
          <PastComplaint
            openPastComplaint={openPastComplaint}
            setOpenPastComplaint={setOpenPastComplaint}
            patientHistoryData={patientHistoryData}
          />
        </div>
      </div>
    </div>
  );
}
